// routes
import { PATH_AUTH } from "../routes/paths";
// api
import { axiosApiInstance } from "../api/axios";
import tokenStorage from "./tokenStorage";
import logger from "../utils/logger";
import { logout as logoutAuth } from "../redux/authSlice";
import { store } from "../redux/store";

// ----------------------------------------------------------------------

export function jwtDecode(token) {
  // Handle null/undefined token (Fixes MEGSAPP-PORTAL-G3)
  if (!token) {
    console.error("jwtDecode: token is null or undefined");
    return null;
  }

  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("jwtDecode: failed to decode token", error);
    return null;
  }
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  // Handle null/malformed token (jwtDecode returns null on error)
  if (!decoded || !decoded.exp) {
    return false;
  }

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

let expiredTimer;

// ----------------------------------------------------------------------

export const tokenExpired = (exp) => {
  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  if (timeLeft <= 0) {
    logger.warn("Token already expired, redirecting to login");
    tokenStorage.clearTokens();
    store.dispatch(logoutAuth());
    window.location.href = PATH_AUTH.loginAdmin;
    return;
  }

  expiredTimer = setTimeout(() => {
    logger.warn("Token expired, redirecting to login");

    tokenStorage.clearTokens();
    store.dispatch(logoutAuth());

    window.location.href = PATH_AUTH.loginAdmin;
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken) => {
  if (accessToken) {
    try {
      tokenStorage.setAccessToken(accessToken);

      if (tokenStorage.requiresAuthHeader()) {
        axiosApiInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      }

      // This function below will handle when token is expired
      const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
      tokenExpired(exp);
    } catch (error) {
      console.error("Error setting session:", error);
      tokenStorage.setAccessToken(null);
      delete axiosApiInstance.defaults.headers.common.Authorization;
    }
  } else {
    clearTimeout(expiredTimer);
    tokenStorage.setAccessToken(null);
    delete axiosApiInstance.defaults.headers.common.Authorization;
  }
};

export const setRefresh = (refreshToken) => {
  tokenStorage.setRefreshToken(refreshToken);
};

// NOTE: setDistibutorType removed - role type is stored in Redux (state.auth.selectedRole.role)
// The legacy distributorType key is still cleaned up in JwtContext.logout() for backward compat
